module.exports = __webpack_public_path__ + "img/text-barzahlung.9595a78e.png";